module.exports = __webpack_public_path__ + "img/slide-images-01.782dc07e.jpg";